import Pusher from "pusher-js";
import Tabs from "./tabs";

class bindChannels {
  /**
   * @function CodeEditor.bindChannels.constructor
   */
  constructor() {
    this.socket_id = "socket_id";
    // this.pusher = new Pusher('c0061876031b537dddb7', {
    // 	cluster: 'eu',
    this.pusher = new Pusher("b85a7a3043e28945c323", {
      cluster: "us2",
      authEndpoint: "/api/v1/pusher/auth",
      auth: {
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
        }
      }
    });

    this.clientChannel = null;
    this.generalChannel = null;
  }

  /**
   * sets the binders for the channels
   * @function bindChannels
   * @return {undefined}
   */
  bindChannels() {
    const channel = this.generalChannel;
    // let groupChannel = pusher.subscribe('private-ixcanul');
    console.log(channel);
    let usertitle = channelData => {
      const { user_name, user_email, user_id } = channelData;
      // addToUserGroup({ name: user_name, email: user_email, id: user_id });
      if (user_name && user_name.length > 0) {
        return user_name;
      } else if (user_email && user_email.length > 0) {
        return user_email;
      }
      return "Volcanic trooper" + user_id;
    };

    channel.bind("connected", function(data) {
      console.warn("data:connected ", data);
    });
    channel.bind("file-updated", function(data) {
      if (window.socketId !== data.socket_id) {
        let file = Tabs.getTabByKey(data.key);
        if (window.socketId !== data.socket_id && file) {
          console.log("An event was triggered: ", data);
          CodeEditor.UI.notif({
            icon: "icon-person",
            title: " ",
            message: data.title + " was modified by <b>" + usertitle(data) + "</b>"
          });
        }
        if (!file) {
          return false;
        }
        CodeEditor.Main.loadFile(tree.getNodeByKey(String(data.key)), null, null, null, true).then(data =>
          console.log(data)
        );
        return true;
      }
      return false;
    });
    channel.bind("file-created", data => {
      if (window.socketId !== data.socket_id) {
        CodeEditor.Tree.reload();
      }
    });
    channel.bind("file-destroyed", data => {
      if (window.socketId !== data.socket_id) {
        let tab = Tabs.getTabByKey(data.key);
        if (tab) {
          Tabs.close(tab.config.id, true);
        }
        CodeEditor.Tree.reload();
      }
    });
    channel.bind("theme-opened", data => {
      console.log("theme opened");
      if (window.socketId != data.socket_id) {
        console.log(data);
        CodeEditor.UI.notif({
          icon: "icon-person",
          message: "<b>" + usertitle(data) + "</b> just joined you on this theme!",
          position: "bottomRight"
        });
      }
    });
    channel.bind("file-opened", data => {
      console.log("file opened");
      if (window.socketId != data.socket_id) {
        const name = usertitle(data);
        const slug_name = name.replace(" ", "-").toLowerCase();
        const toast = $("#pusher_file_opened_" + slug_name);
        const settings = {
          id: "pusher_file_opened_" + slug_name,
          icon: "icon-person",
          message: `<b> ${name} </b> just opened<br><ul><li>${data.path} </li></ul>`,
          position: "bottomRight",
          progressBar: false
        };
        if (toast.length) {
          const new_settings = $.extend(false, settings, {
            replace: true,
            reset_timeout: true,
            id: "pusher_file_opened_" + slug_name,
            message: function(current) {
              const range = document.createRange();
              const fragment = range.createContextualFragment(`<div>${current}</div>`);
              const LIFrag = range.createContextualFragment(`<li>${data.path}</li>`);
              fragment.querySelector("ul").appendChild(LIFrag);
              return fragment.firstElementChild.innerHTML;
            }
          });
          CodeEditor.UI.notif(new_settings);
        } else {
          CodeEditor.UI.notif(settings);
        }
      }
    });
    console.log("%c listening to socket channels.. ", "background-color: green; color:#fff");
    return undefined;
  }

  /**
   * @function bindClientChannels
   * @return {undefined}
   */
  bindClientChannels() {
    const channel = this.clientChannel;
    channel.bind();
    console.log("%c listening to client socket channels.. ", "background-color: green; color:#fff");
  }

  /**
   * Trigger an event on the fly from outside the constructor
   * @function triggerEvent
   * @param  {Object} options  an object containing information about the event
   * @return {Boolean} {description}
   */
  triggerEvent(options = { eventName: "customEvent", data: {} }) {
    console.log("%c trigger...", "background-color: #2060e0");
    try {
      this.clientChannel.trigger("client-" + options.eventName, options.data);
    } catch (error) {
      console.error(error);
    }
    return true;
  }

  /**
   * @function bindEvent
   * @param  {String} eventName  a string contains the name of the client event
   * @param  {Function} callback a callback for the event
   * @return {Boolean} {description}
   */
  bindEvent(
    eventName = "customEvent",
    callback = () => {
      console.log("callback not set");
    }
  ) {
    console.log("%c binder...", "background-color: #2060e0");
    this.clientChannel.bind("client-" + eventName, callback);
    return true;
  }

  /**
   * @method subscribe
   * @param  {string} channel a string that defines the channel id
   * @return {undefined} undefined
   */
  subscribe(channel = "theme-" + $(".editor-wrapper").attr("data-theme-uuid")) {
    this.generalChannel = this.pusher.subscribe(channel);
    this.bindChannels();
    return undefined;
  }

  /**
   * @method presenceChannel
   * @param  {string} channel a string that defines the channel id
   * @return {undefined} undefined
   */
  presenceChannel(channel = $(".editor-wrapper").attr("data-theme-uuid")) {
    this.clientChannel = this.pusher.subscribe("presence-theme-" + channel);
    this.bindClientChannels();
    return undefined;
  }
  /**
   * set the socket and binds the channels
   * @function setSocket
   * @param  {String} socket the socket_id
   * @return {undefined}
   */
  setSocket(socket = window.socketId) {
    this.socket_id = socket;
    console.log(socket);
    return undefined;
  }
}

export default new bindChannels();
